import React from 'react';
// NOTE: ApolloClient needs to be imported from apollo-client
// and not apollo-boost, as you won't get all the config options
// if you import from 'apollo-boost'
// https://github.com/apollographql/apollo-client/issues/3421
import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http';
import { ApolloProvider } from 'react-apollo';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

import config from 'config';

const httpLink = createHttpLink({
  uri: config.GRAPHQL_URL,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('accessToken') || '';

  return {
    headers: {
      ...headers,
      Authorization: token.replace(/"/g, ''),
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});


const Provider = ({ children }) => (
  <ApolloProvider client={client}>
    {children}
  </ApolloProvider>
);

export default Provider;
